import React from 'react';
import { Box } from '@mui/material';
import {
    BeneficiaireEffectifWidget,
    type BeneficiaireEffectifWidgetType,
} from '../../molecules/BeneficiaireEffectifWidget';

export type BeneficiaireEffectifListProps = {
    items?: Array<BeneficiaireEffectifWidgetType>;
};

export const BeneficiaireEffectifList: React.FunctionComponent<BeneficiaireEffectifListProps> =
    function (props: BeneficiaireEffectifListProps) {
        const { items } = props;
        return (
            <Box>
                {items
                    ? items.map((itemProps: BeneficiaireEffectifWidgetType, index) => (
                          <BeneficiaireEffectifWidget
                              key={`beneficiaire-${itemProps.beneficiaire.nom}-${itemProps.beneficiaire.prenom}}`}
                              {...itemProps}
                              index={index}
                          />
                      ))
                    : null}
            </Box>
        );
    };
